
export default function Contact() {
  return (
    <footer className="bg-[#1A1F2E] text-white py-20 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Top Section */}
        <div className="flex items-center justify-between mb-16">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/d6d88cda-a805-4142-99ea-0490305fd43f.png" 
              alt="TUTTO SRL Logo" 
              className="h-12 w-auto"
            />
            <span className="text-2xl font-medium">TUTTO SRL</span>
          </div>
          <p className="text-sm text-gray-400">Building the future of iOS applications</p>
        </div>

        {/* Main Footer Grid */}
        <div className="grid grid-cols-4 gap-20 mb-16">
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-5">
              <li><a href="#home" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">Home</a></li>
              <li><a href="#about" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">About</a></li>
              <li><a href="#products" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">Products</a></li>
              <li><a href="#features" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">Features</a></li>
            </ul>
          </div>

          {/* Our Apps */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Our Apps</h3>
            <ul className="space-y-5">
              <li><span className="text-sm text-gray-400">VPN Solution</span></li>
              <li><span className="text-sm text-gray-400">Device Cleaner</span></li>
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Get in Touch</h3>
            <ul className="space-y-4">
              <li className="text-sm">
                <span className="text-gray-500">Address:</span>
                <span className="text-gray-300 ml-2">VIALE TICA 103</span>
              </li>
              <li className="text-sm">
                <span className="text-gray-500">City:</span>
                <span className="text-gray-300 ml-2">SIRACUSA</span>
              </li>
              <li className="text-sm">
                <span className="text-gray-500">Zip:</span>
                <span className="text-gray-300 ml-2">96100</span>
              </li>
              <li className="text-sm">
                <span className="text-gray-500">Country:</span>
                <span className="text-gray-300 ml-2">Italy</span>
              </li>
              <li className="text-sm">
                <span className="text-gray-500">Email:</span>
                <a href="mailto:help@tuttosrl.com" className="text-gray-300 ml-2 hover:text-white transition-colors cursor-pointer">help@tuttosrl.com</a>
              </li>
              <li className="text-sm">
                <span className="text-gray-500">Phone:</span>
                <a href="tel:+17087874157" className="text-gray-300 ml-2 hover:text-white transition-colors cursor-pointer">+1 7087874157</a>
              </li>
            </ul>
          </div>

          {/* Copyright & Social */}
          <div className="text-right">
            <p className="text-xl font-serif mb-2">© 2025 TUTTO SRL</p>
            <p className="text-sm text-gray-400 mb-6">All rights reserved</p>
            <ul className="space-y-4">
              <li><span className="text-sm text-gray-400 underline cursor-pointer hover:text-white transition-colors">LinkedIn</span></li>
              <li><span className="text-sm text-gray-400 underline cursor-pointer hover:text-white transition-colors">Twitter</span></li>
              <li><span className="text-sm text-gray-400 underline cursor-pointer hover:text-white transition-colors">Facebook</span></li>
              <li><span className="text-sm text-gray-400 underline cursor-pointer hover:text-white transition-colors">Instagram</span></li>
            </ul>
          </div>
        </div>

        {/* Bottom Visual Area */}
        <div className="grid grid-cols-3 gap-12 items-center pt-12 border-t border-gray-700">
          {/* Left Image */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/aa1b99e60ee847d9b9aaa0723f7a6089.jpg"
              alt="iOS Devices"
              className="w-full h-48 object-cover object-top rounded-2xl"
            />
          </div>

          {/* Middle Text */}
          <div className="text-center">
            <p className="text-4xl font-serif leading-relaxed text-gray-200">
              Innovation<br />meets<br />Excellence
            </p>
          </div>

          {/* Right Newsletter */}
          <div className="text-right">
            <p className="text-sm text-gray-400 mb-4">
              Stay Updated<br />with Our Latest News
            </p>
            <div className="flex gap-2 justify-end">
              <input
                type="email"
                placeholder="Enter your email"
                className="px-4 py-3 bg-transparent border border-gray-600 rounded-lg text-sm text-white placeholder-gray-500 focus:outline-none focus:border-gray-400 transition-colors w-64"
              />
              <button className="px-6 py-3 bg-[#4A90E2] text-white rounded-lg text-sm font-medium hover:bg-[#3A7BC8] transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer">
                Subscribe
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Quick Link */}
        <div className="text-center mt-12 pt-8 border-t border-gray-700">
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-xs text-gray-500 hover:text-gray-400 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
